import Vue from 'vue'
import store from '@/store'
import ElementUI from 'element-ui'
//import '@/theme/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/font-awesome.min.css'
import '@/assets/css/style.css'
import router from '@/router'
import Config from '@/config'
import Function from '@/function'
import axios from '@/http'
import * as custom from '@/filter'
import {
	Loading
} from 'element-ui';
import '@/assets/css/element-variables.scss'
import '@/assets/iconfont/iconfont.js'
import IconSvg from '@/components/icon-svg'
import JSEncrypt from 'jsencrypt'; //引入模块
import VueRouter from "vue-router";
//import * as echarts from 'echarts';
import LemonIMUI from 'lemon-imui';
import 'lemon-imui/dist/index.css';

//import 'element-ui/lib/theme-chalk/base.css';
import App from '@/App.vue'

import katex from 'katex'
// !import 不能忘记引入katex的样式
import 'katex/dist/katex.css'
// 引入katex下的自动渲染函数
import renderMathInElement from 'katex/dist/contrib/auto-render'

import VueCookies from 'vue-cookies';


Vue.use(VueCookies);
Vue.use(LemonIMUI);
Vue.component('icon-svg', IconSvg)

Vue.prototype.$Config = Config
Vue.prototype.$Func = Function
Vue.prototype.$http = axios
Vue.prototype.$loading = Loading
Vue.prototype.$jsEncrypt = JSEncrypt;

// 定义自动渲染的配置参数,这些参数根据你的需求进行修改，下面的参数是官网上抄下来的
const renderOption = {
  delimiters: [
    {left: '$$', right: '$$', display: true},
    {left: '$', right: '$', display: false},
    {left: '\\(', right: '\\)', display: false},
    {left: '\\[', right: '\\]', display: true}
  ],
  throwOnError : false
}

// 挂载自动渲染函数到vue原型
Vue.prototype.$formula = function (dom) {
  renderMathInElement(dom, renderOption)
}

Object.keys(custom).forEach(key => {
	Vue.filter(key, custom[key])
})
// Object.defineProperties(Vue.prototype, {
//   echarts: { get: () => echarts }
// });



// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
// 	return originalPush.call(this, location).catch((err) => err);
// };



Vue.use(ElementUI)
new Vue({
	el: '#app',
	router,
	store,
	axios,
	render: h => h(App)
})
